import { useState } from 'react';
import { SearchBar } from '../../../components/common/SearchBar';
import FilterBy from '../../../components/common/FilterBy';
import { SearchFilterContainer } from '../../../assets/styles/layout/searchFilter.styled';
import ChildHeader from '../../../components/ui/ChildHeader';
import { TableBody, TableCell, TableRow } from '@mui/material';
import axios from 'axios';
import TableCustom from '../../../components/common/customTable/TableCustom';
import useDebounce from '../../../hooks/useDebounce';
import React from 'react';
import formatDate from '../../../components/common/formatDate';
import { useQuery } from '../../../hooks/UseQuery';
import CustomPagination from '../../../components/common/CustomPagination';
import { CardIconButton } from '../../../components/common/button/CustomIconButton';
import { constants } from './constants';
import { useNavigate } from 'react-router-dom';
import {
  StyledTableRow,
  StyledTableCell,
  style1,
} from '../helpers/module.styled';

const filterOptions = [
  { value: 'part_number', name: 'A-Z' },
  { value: 'createdAt', name: 'Most Recent First' },
  { value: 'createdAt_old', name: 'Oldest First' },
];

const tableHeaderObj = [
  [
    { text: '#', style: { ...style1, minWidth: '140px' } },
    { text: 'Material Name', style: { ...style1, minWidth: '140px' } },
    { text: 'Part Name', style: { ...style1, minWidth: '140px' } },
    { text: 'Part Number', style: { ...style1, minWidth: '140px' } },
    { text: 'Vendor 1', style: { ...style1, minWidth: '140px' } },
    { text: 'Vendor 2', style: { ...style1, minWidth: '140px' } },
    { text: 'Vendor 3', style: { ...style1, minWidth: '140px' } },
    { text: 'Created At', style: { ...style1, minWidth: '140px' } },
    { text: 'Stock Resister', style: { ...style1, minWidth: '140px' } },
  ],
];

const RiPart = () => {
  const [data, setData] = useState<any[]>([]);
  const [render, setRender] = useState(false);
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const search = useQuery('search');
  const filter = useQuery('filter');
  const page = useQuery('page') || 1;
  const navigate = useNavigate();
  const fetchData = async () => {
    const res: any = await axios
      .get(
        `/api/riDepartment/riPart?page=${page}&sortBy=${
          filter || 'part_number'
        }&search=${search}&perPage=${10}`
      )
      .catch((err) => {
        console.log(err);
      });
    setData(res.data?.result);
    setPerPage(res.data?.perPage);
    setTotalPages(res.data?.pages);
  };

  useDebounce(fetchData, 1000, [page, search, render, filter]);

  return (
    <>
      <ChildHeader text="RI PARTS"></ChildHeader>
      <SearchFilterContainer filter={true}>
        <SearchBar label="Search Material Name / Part name / Part number" />
        <FilterBy label="Sort" options={filterOptions} />
      </SearchFilterContainer>
      <TableCustom tableHeaderObj={tableHeaderObj}>
        <TableBody>
          {data &&
            data.map((item: any, index: number) => (
              <React.Fragment key={index}>
                <StyledTableRow index={index}>
                  <StyledTableCell align="center">
                    {perPage * (+page - 1) + index + 1}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {item?.part_name}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {item?.part_name_2}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {item?.part_number}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {item?.vendor_id?.vender_name}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {item?.vendor_id_2?.vender_name}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {item?.vendor_id_3?.vender_name}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {formatDate(item?.createdAt || '')}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    <CardIconButton
                      tooltipTitle="Store Resister"
                      onClick={() => {
                        navigate(
                          `${constants.navigate.view}/${item._id}?part_name=${item?.part_name}&part_number=${item?.part_number}`
                        );
                      }}
                    />
                  </StyledTableCell>
                </StyledTableRow>
              </React.Fragment>
            ))}
        </TableBody>
      </TableCustom>
      <CustomPagination totalPage={totalPages} />
    </>
  );
};

export default RiPart;
